import { Component, EventEmitter, Inject, Output } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { Clipboard } from '@angular/cdk/clipboard'
import { ComprasOrdemServicoService } from '../../../core/services/reserva-compras/compras-ordem-servico/compras-ordem-servico.service'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { ErrorRequestModel } from '../../../core/models/response.model'
import { NotificarComprasOsResponse } from '../../../core/models/reserva-compras.model'

@Component({
  selector: 'reserva-compras-notificar-modal',
  imports: [FormsModule, MatButton, MatProgressSpinner, MatCheckboxModule],
  templateUrl: './reserva-compras-notificar-modal.component.html',
  styleUrl: './reserva-compras-notificar-modal.component.scss',
  standalone: true,
})
export class ReservaComprasNotificarModalComponent {
  constructor(
    private comprasOrdemServicoService: ComprasOrdemServicoService,
    private snackbar: SnackbarCustomService,
    private clipboard: Clipboard,
    private dialogRef: MatDialogRef<ReservaComprasNotificarModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { comprasOsIds: string[] },
  ) {
    this.comprasOsIds = data.comprasOsIds
  }

  @Output() response = new EventEmitter()

  comprasOsIds: string[] = []
  sending = false
  sent = false
  enviarEmail = true
  gerarLinkWhatsApp = true
  emailsEnviados = 0
  linksWhatsApp: NotificarComprasOsResponse['linksWhatsApp'] = []

  notificar() {
    if (!this.enviarEmail && !this.gerarLinkWhatsApp) {
      this.snackbar.warning(
        'Selecione ao menos uma forma de envio (e-mail ou WhatsApp).',
      )
      return
    }
    this.sending = true
    this.comprasOrdemServicoService
      .notificar({
        comprasOsIds: this.comprasOsIds,
        enviarEmail: this.enviarEmail,
        gerarLinkWhatsApp: this.gerarLinkWhatsApp,
      })
      .subscribe({
        next: (response: any) => {
          this.sending = false
          this.emailsEnviados = response.data?.emailsEnviados ?? 0
          this.linksWhatsApp = response.data?.linksWhatsApp ?? []
          this.response.emit(true)
          if (this.gerarLinkWhatsApp) {
            this.sent = true
          } else {
            this.snackbar.success(
              `${this.emailsEnviados} e-mail(s) enviado(s) ao(s) fornecedor(es).`,
            )
            this.close()
          }
        },
        error: (err: ErrorRequestModel) => {
          this.sending = false
          this.snackbar.errorRequest(err)
        },
      })
  }

  copyLink(link: string) {
    if (this.clipboard.copy(link)) {
      this.snackbar.success('Link copiado para a área de transferência.')
    }
  }

  openLink(link: string) {
    window.open(link, '_blank')
  }

  close() {
    this.dialogRef.close()
  }
}
